import React from 'react'

import { Paragraph, Title } from '@components/atoms'

import { cardSimulateStyles } from './style'

const {
	Container,
	content1,
	/* containerRating,
	StarFilled,
	StarEmpty, */
} = cardSimulateStyles

type StitchesProps = React.ComponentProps<typeof Container>

interface CardListProps extends StitchesProps {
	name: string
	questionNumber: number
	rating: number
}

export const CardSimulate = ({
	name,
	questionNumber,
	...props
}: CardListProps) => {
	return (
		<Container {...props}>
			<Title variant='h6' color='$neutral100'>
				{name}
			</Title>
			<div style={{ width: '100%' }}>
				<div className={content1()}>
					<Paragraph paragraphType='p2' css={{ color: '$neutral90' }}>
						{questionNumber} questões
					</Paragraph>
				</div>
			</div>
		</Container>
	)
}
